import React from 'react';
import PropTypes from 'prop-types';
import ApplicationSection from '../ApplicationSection/ApplicationSection'
import JumptoSection from '../JumptoSection/JumptoSection';
import { getDynamicClassName } from '../../../Utility/ApplicationFormUtility';

/**
 * Application form section
 *
 * @param {object} props
 * @param {'references' | ''} props.type
 * @param {string} props.title
 * @param {object[]} props.questions
 * @param {string[]} props.references
 * @param {boolean} props.isLast
 *
 * @returns {ReactElement}
 */

const StepConfigForm = ({
  type = false,
  title = '',
  subTitle = '',
  questions = [],
  errors = [],
  isLast = false,
  sfid,
  onChange = () => { },
  deleteApplicationDocument = () => { },
  emailConfimation,
  emailConfimationErrors,
  handleEmailConfirmation,
  step,
  onSuggestiveSelect = () => { },
  onQuestionSuggestiveSelect = () => { },
  handleAddressSelection = () => { },
  handleClickShowTearmsCondictionModal = () => { },
  agreementResponse = () => { },
  setModalState = () => { },
  handleClickOnDocuSignShow = () => { },
  handleClickEsignShow = () => { },
  buttonSecondaryColor,
  allowApplicantUploadsAfterDeadline,
  onBlur = () => { },
  isOpenPassword = false,
  handleSetPassword = () => { },
  state = {},
  password = '',
  thirteenYearAge,
  setThirteenYearAge = () => { },
  applicationId,
  formattedDate = '',
  handleSubmit,
  primaryColor,
  sections = {},
  renderFormattedSections = () => { },
  handlejumpto = () => { },
  scholarship,
  currectStepId,
  stepStatus = '',
  submittedSteps = [],
  isDonationForm = false,
  handleClearEncryptedValue,
  isMobileScreen = false,
  isIpadScreen= false,
  ...props
}) => {

  const customClassName = getDynamicClassName(isDonationForm, 'donate-form-page', 'scholarship-form-page') 
  const getSections = renderFormattedSections(sections)
  return (
  <form className={`application__form application__step ${customClassName}`}>
    <ApplicationSection
        title={title}
        subTitle={subTitle}
        questions={questions}
        setModalState={setModalState}
        references={[]}
        handleClickEsignShow={handleClickEsignShow}
        handleClickOnDocuSignShow={handleClickOnDocuSignShow}
        key={sfid}
        onChange={onChange}
        handleClickShowTearmsCondictionModal={handleClickShowTearmsCondictionModal}
        deleteApplicationDocument = {deleteApplicationDocument}
        errors={errors}
        step={step}
        emailConfimation={emailConfimation}
        emailConfimationErrors={emailConfimationErrors}
        handleEmailConfirmation={handleEmailConfirmation}
        onSuggestiveSelect={onSuggestiveSelect}
        onQuestionSuggestiveSelect={onQuestionSuggestiveSelect}
        handleAddressSelection={handleAddressSelection}
        buttonSecondaryColor={buttonSecondaryColor}
        allowApplicantUploadsAfterDeadline={allowApplicantUploadsAfterDeadline}
        onBlur={onBlur}
        isOpenPassword={isOpenPassword}
        handleSetPassword={handleSetPassword}
        passwordError={state}
        password={password}
        thirteenYearAge={thirteenYearAge}
        setThirteenYearAge={setThirteenYearAge}
        applicationId={applicationId}
        formattedDate={formattedDate}
        primaryColor={primaryColor}
        handleClearEncryptedValue={handleClearEncryptedValue}
      />
      {applicationId && scholarship.allow_to_view_entire_steps__c && (isMobileScreen || isIpadScreen)  &&
        <JumptoSection
          handlejumpto={handlejumpto}
          currectStepId={currectStepId}
          getSections={getSections}
          buttonSecondaryColor={buttonSecondaryColor}
          submittedSteps = { submittedSteps }
          stepStatus = { stepStatus }
          isMobileOrIpad={isMobileScreen || isIpadScreen}
        />
      }

    </form>
  )
}

StepConfigForm.propTypes = {
  scholarship: PropTypes.shape({
    allow_to_view_entire_steps__c: PropTypes.bool,
  }),
  isMobileScreen: PropTypes.bool,
  isIpadScreen: PropTypes.bool,
  isDonationForm: PropTypes.bool
}
export default StepConfigForm;